import { VIDEO_FILE_LIMITS } from '../constants';

/**
 * Format bytes to MB with 1 decimal place
 */
export const formatMB = (bytes: number): string => {
  return (bytes / (1024 * 1024)).toFixed(1);
};

/**
 * Validate video file size
 * Returns: { valid: boolean, error?: string, warning?: string }
 */
export const validateVideoFileSize = (
  file: File
): { 
  valid: boolean; 
  error?: string; 
  warning?: string;
  sizeMB: number;
} => {
  const sizeMB = file.size / (1024 * 1024);
  
  // Check if exceeds maximum size
  if (file.size > VIDEO_FILE_LIMITS.MAX_SIZE_BYTES) {
    return {
      valid: false,
      error: `Video file is too large (${formatMB(file.size)} MB).\n\n` +
             `Maximum allowed size is ${VIDEO_FILE_LIMITS.MAX_SIZE_MB} MB.\n\n` +
             `Please compress your video before uploading.`,
      sizeMB
    };
  }
  
  // Check if should show warning
  if (file.size > VIDEO_FILE_LIMITS.WARNING_SIZE_BYTES) {
    return {
      valid: true,
      warning: `⚠️ Large File Warning\n\n` +
               `Your video is ${formatMB(file.size)} MB.\n\n` +
               `Files over ${VIDEO_FILE_LIMITS.WARNING_SIZE_MB} MB may take longer to upload and process.\n\n` +
               `Maximum size is ${VIDEO_FILE_LIMITS.MAX_SIZE_MB} MB.\n\n` +
               `Do you want to continue?`,
      sizeMB
    };
  }
  
  // File size is acceptable
  return { valid: true, sizeMB };
};

/**
 * Show compression guide to user
 */
export const showCompressionGuide = (currentSizeMB: number) => {
  const message = 
    `📹 VIDEO TOO LARGE\n\n` +
    `Your video is ${currentSizeMB.toFixed(1)} MB.\n` +
    `Maximum allowed: ${VIDEO_FILE_LIMITS.MAX_SIZE_MB} MB\n\n` +
    `HOW TO COMPRESS:\n\n` +
    `Option 1 - Online (Free):\n` +
    `• Visit: freeconvert.com/video-compressor\n` +
    `• Upload your video\n` +
    `• Select target size: ${VIDEO_FILE_LIMITS.MAX_SIZE_MB} MB or less\n` +
    `• Download compressed video\n\n` +
    `Option 2 - HandBrake (Desktop):\n` +
    `• Download: handbrake.fr\n` +
    `• Use preset: "Web" or "Fast 720p30"\n` +
    `• Adjust quality slider if needed\n\n` +
    `Option 3 - Mobile Apps:\n` +
    `• iOS: Video Compress\n` +
    `• Android: Video Compressor\n\n` +
    `💡 Tip: 720p quality works great for dance videos\n` +
    `and keeps file size manageable!`;
  
  return message;
};